import { NgModule } from "@angular/core";
import { RoleDirective } from "./role.directive";

@NgModule({
    imports: [],
    declarations: [RoleDirective],
    exports: [RoleDirective],
})
export class RoleModule {}
